import { render, staticRenderFns } from "./GestaoContatos.vue?vue&type=template&id=17b34baa&scoped=true&"
import script from "./GestaoContatos.vue?vue&type=script&lang=js&"
export * from "./GestaoContatos.vue?vue&type=script&lang=js&"
import style0 from "./GestaoContatos.vue?vue&type=style&index=0&id=17b34baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b34baa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VContainer,VDataTable,VDialog,VFlex,VLayout,VProgressCircular,VSelect,VSpacer,VTextField})
